<template>
  <loading-component v-if="isLoading" />
  <div class="columns is-multiline" v-else>
    <modal-image v-if="imageModal" :close="closeModal" :image="image" />
    <div class="column is-12 is-paddingless is-marginless has-text-left titleCard is-flex">
      <div>
        {{ detail.productName }} ({{ detail.name }}) -
        <span class="tag" :class="[
          detail.statusName == 'Pendiente' ? 'is-info' : '',
          detail.statusName == 'Preaprobado' ? 'is-warning' : '',
          detail.statusName == 'Activo' ? 'is-success' : '',
        ]">{{ detail.statusName }}</span>
      </div>
    </div>

    <div class="column is-12 separator"></div>
    <div class="column is-12">
      <p class="title is-4" style="display: inline-block;"><strong>Calificacion del dispositivo: </strong></p>
      {{ ' ' }}
      <span v-if="!this.data?.degree">N/A</span>
      <span v-if="this.data?.degree" class="tag is-medium" :class="{
        'has-background-color-a': this.data?.degree === 'A',
        'has-background-color-ab': this.data?.degree === 'AB',
        'has-background-color-c': this.data?.degree === 'C'
      }" :data-tooltip="tooltip"><strong style="color: white;">{{ this.data?.degree }}</strong></span>
      {{ ' ' }}
      <!-- Icono de edición -->
      <span v-if="this.data?.degree" class="icon is-clickable" style="vertical-align: sub;" @click="isEditing = !isEditing">
        <i class="material-icons click">edit</i>
      </span>

      <!-- Menú desplegable para seleccionar el grado -->
      <div v-if="isEditing" class="select">
        <select v-model="data.degree" @change="handleUpdateDegree">
          <option value="A">A</option>
          <option value="AB">AB</option>
          <option value="C">C</option>
        </select>
      </div>
      <div class="columns">
        <p v-if="!data?.diagnosticId" class="column is-6"><strong>El usuario no realizó el diagnostico.</strong></p>
        <div v-else class="column is-6">
          <table class="table is-fullwidth is-hoverable price-table info-table">
            <thead>
              <tr>
                <th colspan="2">Diagnóstico del dispositivo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="info-table__key">Marca</td>
                <td class="has-text-right">{{ data?.diagnosticBrand ?? 'N/A' }}</td>
              </tr>
              <tr>
                <td class="info-table__key">Modelo</td>
                <td class="has-text-right">{{ data?.diagnosticModel ?? 'N/A' }}</td>
              </tr>
              <tr>
                <td class="info-table__key">Almacenamiento</td>
                <td class="has-text-right">{{ data?.diagnosticStorage ?? 'N/A' }}</td>
              </tr>
              <tr>
                <td class="info-table__key">IMEI</td>
                <td class="has-text-right">{{ data?.imei ?? 'N/A' }}</td>
              </tr>
              <tr>
                <td class="info-table__key">ID del dispositivo</td>
                <td class="has-text-right">{{ data?.deviceId || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="column is-6">
          <div class="promo-banner" :class="data?.promoPartner ? 'promo-banner--active' : 'promo-banner--none'">
            <span class="promo-banner__label">Código promocional</span>
            <template v-if="data?.promoPartner">
              <span class="promo-banner__partner">{{ data.promoPartner.name }}</span>
              <span v-if="data.promoPartner.promotionCode" class="promo-banner__code">
                {{ data.promoPartner.promotionCode }}
              </span>
              <span v-if="data.promoPartner.isSpecial" class="tag is-success">
                AB {{ Math.round(data.promoPartner.abGrade * 100) }}%
              </span>
            </template>
            <span v-else class="promo-banner__partner">No tiene</span>
          </div>

          <div v-if="data?.priceOrigin" class="price-origin">
            <span>
              Origen del precio:
              <strong :class="{ 'has-text-link': data.priceOrigin.type === 'partner' }">{{ data.priceOrigin.label }}</strong>
            </span>
            <span>RAM: <strong>{{ data.ramGb ? `${data.ramGb} GB` : 'Desconocida' }}</strong></span>
          </div>

          <p v-if="!data?.HasPricing && !data?.showMarketPriceDate">
            <strong>El usuario no realizó la búsqueda del precio estimado.</strong>
          </p>
          <p v-else-if="!data?.HasPricing && !!data?.showMarketPriceDate">
            <strong>No hay precio estimado disponible.</strong>
          </p>
          <table v-else class="table is-fullwidth is-hoverable price-table">
            <thead>
              <tr>
                <th>Grado</th>
                <th class="has-text-right">Precio</th>
                <th class="has-text-right">%</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(price, grade) in data?.pricing" :key="grade"
                :class="{ 'price-row--shown': shownPrice.type === 'grade' && shownPrice.grade === grade }">
                <td>
                  <span class="grade-dot" :class="{
                    'has-background-color-a': grade === 'A',
                    'has-background-color-ab': grade === 'AB',
                    'has-background-color-b': grade === 'B',
                    'has-background-color-c': grade === 'C'
                  }"></span>
                  Grado {{ grade }}
                  <span v-if="shownPrice.type === 'grade' && shownPrice.grade === grade" class="tag is-success is-light ml-2">Precio mostrado al usuario</span>
                </td>
                <td class="has-text-right price-cell">${{ price }}</td>
                <td class="has-text-right has-text-grey is-size-7">—</td>
              </tr>
            </tbody>
            <tbody v-if="data?.partnerPricing && data.partnerPricing.length">
              <tr class="price-table__subhead">
                <td colspan="3">Precios personalizados (grado AB)</td>
              </tr>
              <tr v-for="partner in data.partnerPricing" :key="partner.code"
                :class="{ 'price-row--shown': shownPrice.type === 'partner' && shownPrice.code === partner.code }">
                <td>
                  <span class="grade-dot grade-dot--partner"></span>
                  {{ partner.name }}
                  <span v-if="shownPrice.type === 'partner' && shownPrice.code === partner.code" class="tag is-success is-light ml-2">Precio mostrado al usuario</span>
                </td>
                <td class="has-text-right price-cell">${{ partner.ab }}</td>
                <td class="has-text-right has-text-grey is-size-7">{{ Math.round(partner.abGrade * 100) }}%</td>
              </tr>
            </tbody>
            <tbody v-if="data?.consignmentPricing">
              <tr class="price-table__subhead">
                <td colspan="3">Oferta de consignación</td>
              </tr>
              <tr :class="{ 'price-row--shown': shownPrice.type === 'consignment' }">
                <td>
                  <span class="grade-dot grade-dot--consignment"></span>
                  {{ data.consignmentPricing.label || 'Consignación' }}
                  <span v-if="shownPrice.type === 'consignment'" class="tag is-success is-light ml-2">Precio mostrado al usuario</span>
                </td>
                <td class="has-text-right price-cell">${{ data.consignmentPricing.amount }}</td>
                <td class="has-text-right has-text-grey is-size-7">+{{ Math.round(data.consignmentPricing.bonusPct * 100) }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="column is-12"></div>
      <p v-if="this.data?.screen === null"><strong>El usuario aún no ha realizado el diagnóstico de este producto.</strong></p>
      <table class="table is-fullwidth is-hoverable" v-else>
        <thead>
          <tr>
            <th>Prueba</th>
            <th>Original</th>
            <th>Input</th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in computedData" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.original }}</td>
            <td>
              <template v-if="isUrl(item.input)">
                <a :href="item.input" class="button is-link" download rel="noopener noreferrer">
                  Descargar
                </a>
              </template>
              <template v-else>
                {{ item.input }}
              </template>
            </td>
            <td>
              <span
                v-if="item.name === 'Porcentaje de bateria'"
                class="tag is-medium"
                :class="{
                  'is-success has-text-light': parseInt(item.status) > 93,
                  'is-warning': parseInt(item.status) <= 93 && item.status !== 'Sin información',
                  'is-light': item.status === 'Sin información'
                }"
              >
                {{ item.status }}
              </span>
              <span
                v-else
                class="tag is-medium"
                :class="{ 'is-success': item.status === 'Aprobado', 'is-danger': item.status === 'Fallido' }"
              >
                {{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="column is-12"></div>
      <p class="auto-tests-heading">
        <strong>Pruebas automáticas (GivU Pro)</strong>
        <template v-if="autoTestsSummary">
          <span class="tag is-medium" :class="{
            'has-background-color-a': autoTestsSummary.band === 'A',
            'has-background-color-ab': autoTestsSummary.band === 'B',
            'has-background-color-c': autoTestsSummary.band === 'C' || autoTestsSummary.band === 'D',
            'is-danger': autoTestsSummary.band === 'F'
          }"><strong style="color: white;">Puntaje {{ autoTestsSummary.score }} &middot; Banda {{ autoTestsSummary.band }}</strong></span>
          <span v-if="autoTestsSummary.hardFail" class="tag is-danger is-medium">Riesgo de fraude</span>
        </template>
      </p>
      <p v-if="!autoTestRows.length"><strong>El dispositivo no reportó pruebas automáticas.</strong></p>
      <table class="table is-fullwidth is-hoverable" v-else>
        <thead>
          <tr>
            <th>Prueba</th>
            <th>Valor</th>
            <th>Resultado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in autoTestRows" :key="item.testId">
            <td>{{ item.name }}</td>
            <td>{{ item.value }}</td>
            <td>
              <span
                class="tag is-medium"
                :class="{
                  'is-success': item.status === 'Aprobado',
                  'is-danger': item.status === 'Fallido',
                  'is-light': item.status === 'Sin información'
                }"
              >
                {{ item.status }}
              </span>
              <span v-if="item.reason" class="auto-test-reason has-text-grey is-size-7">{{ item.reason }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

const AUTO_TEST_IDS = [
  'battery.level',
  'hardware.storage',
  'software.os-version',
  'software.update-compatibility',
  'connectivity.network-state',
  'connectivity.cellular-generation',
  'connectivity.gps',
  'connectivity.bluetooth',
  'security.device-integrity'
]

const AUTO_TEST_LABELS = {
  'battery.level': 'Nivel de batería',
  'hardware.storage': 'Almacenamiento',
  'software.os-version': 'Versión del sistema',
  'software.update-compatibility': 'Compatibilidad de actualización',
  'connectivity.network-state': 'Estado de red',
  'connectivity.cellular-generation': 'Generación celular',
  'connectivity.gps': 'GPS',
  'connectivity.bluetooth': 'Bluetooth',
  'security.device-integrity': 'Integridad del dispositivo'
}

const AUTO_TEST_REASONS = {
  cancelled: 'Cancelada por el usuario',
  permission_denied: 'Permiso denegado',
  no_hardware: 'Sin hardware',
  not_enrolled: 'Sin registrar',
  lockout: 'Bloqueado',
  timeout: 'Tiempo agotado',
  below_threshold: 'Bajo el umbral',
  no_internet: 'Sin internet',
  powered_off: 'Apagado',
  compromised: 'Comprometido',
  error: 'Error'
}

const NETWORK_STATE_LABELS = {
  WIFI: 'Wi-Fi',
  CELLULAR: 'Datos móviles'
}

const BYTES_IN_GB = 1024 * 1024 * 1024

function formatBytes (bytes) {
  const value = Number(bytes)
  if (!isFinite(value) || value < 0) return null
  return `${(value / BYTES_IN_GB).toFixed(1)} GB`
}

function formatAutoTestValue (testId, value) {
  if (value === null || value === undefined) return 'N/A'
  switch (testId) {
    case 'battery.level':
      return value?.percentage != null ? `${value.percentage}%` : 'N/A'
    case 'hardware.storage': {
      const total = formatBytes(value?.totalBytes)
      const free = formatBytes(value?.freeBytes)
      if (!total && !free) return 'N/A'
      return `${free ?? 'N/A'} libres de ${total ?? 'N/A'}`
    }
    case 'software.os-version':
      return [value?.osName, value?.osVersion].filter(Boolean).join(' ') || 'N/A'
    case 'software.update-compatibility': {
      const current = value?.currentOsVersion
      const latest = value?.latestOsVersion
      if (!current && !latest) return 'N/A'
      if (current === latest) return `${current} (al día)`
      return `${current ?? 'N/A'} → ${latest ?? 'N/A'}`
    }
    case 'connectivity.network-state':
      return NETWORK_STATE_LABELS[value] ?? String(value)
    case 'connectivity.cellular-generation':
      return String(value)
    case 'connectivity.gps': {
      const parts = []
      if (value?.accuracyMeters != null) parts.push(`Precisión ${Number(value.accuracyMeters).toFixed(1)} m`)
      if (value?.jitterMeters != null) parts.push(`Jitter ${Number(value.jitterMeters).toFixed(1)} m`)
      if (value?.ttffMs != null) parts.push(`TTFF ${(Number(value.ttffMs) / 1000).toFixed(1)} s`)
      return parts.length ? parts.join(' · ') : 'N/A'
    }
    case 'connectivity.bluetooth':
      return value?.deviceCount != null
        ? `${value.deviceCount} ${value.deviceCount === 1 ? 'dispositivo' : 'dispositivos'}`
        : 'N/A'
    case 'security.device-integrity': {
      const flags = []
      if (value?.compromised) flags.push('Comprometido')
      if (value?.hookDetected) flags.push('Hooking detectado')
      if (value?.canMockLocation) flags.push('Ubicación simulada')
      return flags.length ? flags.join(' · ') : 'Sin anomalías'
    }
    default:
      return typeof value === 'string' ? value : JSON.stringify(value)
  }
}

export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  components: {
    LoadingComponent: () => import('@/components/ui/Loading')
  },
  data () {
    return {
      imageModal: false,
      image: null,
      data: {},
      isLoading: false,
      isEditing: false,
      tooltip: `Grado A: Pantalla, biometría soportada y registrada, IMEI presente, batería > 93%.${'\n'}Grado AB: (Pantalla + biometría + IMEI) con batería ≤ 93%, o (sin pantalla + biometría + IMEI) con batería > 93%.${'\n'}Grado C: No cumple con las condiciones anteriores.`
    }
  },
  computed: {
    // Determina qué precio es el que realmente ve el usuario:
    // 1) Consignación (si eligió ese modo de venta)
    // 2) Precio de su alianza (si tiene código promocional con precio especial)
    // 3) En cualquier otro caso siempre se le muestra el Grado AB,
    //    independiente del grado real del diagnóstico.
    shownPrice () {
      if (this.data?.consignmentPricing) {
        return { type: 'consignment' }
      }
      const promo = this.data?.promoPartner
      if (promo && promo.isSpecial && promo.code) {
        const match = (this.data?.partnerPricing || []).some((p) => p.code === promo.code)
        if (match) return { type: 'partner', code: promo.code }
      }
      return { type: 'grade', grade: 'AB' }
    },
    autoTestsSummary () {
      return this.data?.autoTests?.summary ?? null
    },
    autoTestRows () {
      const results = this.data?.autoTests?.results
      if (!results || !results.length) return []
      const byTestId = new Map(results.map((result) => [result.testId, result]))
      return AUTO_TEST_IDS.map((testId) => {
        const result = byTestId.get(testId)
        if (!result) {
          return { testId, name: AUTO_TEST_LABELS[testId], value: '-', status: 'Sin información', reason: null }
        }
        return {
          testId,
          name: AUTO_TEST_LABELS[testId],
          value: formatAutoTestValue(testId, result.value),
          status: result.ok ? 'Aprobado' : 'Fallido',
          reason: result.ok ? null : (AUTO_TEST_REASONS[result.reason] ?? AUTO_TEST_REASONS.error)
        }
      })
    },
    computedData () {
      return [
        { name: 'Pantalla', original: '-', input: '-', status: this.data?.screen ? 'Aprobado' : 'Fallido' },
        { name: 'Porcentaje de bateria', original: '-', input: '-', status: this.data?.battery === null ? 'Sin información' : `${this.data?.battery}%` },
        { name: 'Celular liberado', original: '-', input: '-', status: this.data?.unlockedPhone === null ? 'Sin información' : (this.data?.unlockedPhone ? 'Aprobado' : 'Fallido') },
        { name: 'Puerto de carga funcional', original: '-', input: '-', status: this.data?.chargingPort === null ? 'Sin información' : (this.data?.chargingPort ? 'Aprobado' : 'Fallido') },
        { name: 'Sensores biometricos', original: '-', input: '-', status: this.data?.biometricIsSupported ? this.data?.biometricIsEnrolled ? 'Aprobado' : 'Fallido' : 'No compatible' },
        {
          name: 'Altavoces',
          original: this.data?.speakersOriginalPhrase,
          input: this.data?.speakersInputPhrase,
          status: (
            this.data?.speakersOriginalPhrase &&
            this.data?.speakersInputPhrase &&
            (
              this.data?.speakersOriginalPhrase.toLowerCase().includes(this.data?.speakersInputPhrase.toLowerCase()) ||
              this.data?.speakersInputPhrase.toLowerCase().includes(this.data?.speakersOriginalPhrase.toLowerCase())
            )
          ) ? 'Aprobado' : 'Fallido'
        },
        { name: 'Micrófono', original: this.data?.speakersMicOriginalPhrase, input: this.data?.speakersMicInputPhrase, status: this.data?.speakersMicInputPhrase ? 'Aprobado' : 'Fallido' }
      ]
    }
  },
  methods: {
    ...mapActions(['getDiagnostic', 'updateDegree']),
    showImageModal (image) {
      this.image = image
      this.imageModal = true
    },
    closeModal () {
      this.imageModal = false
    },
    isUrl (input) {
      const httpsPattern = /^https:\/\//
      return httpsPattern.test(input)
    },
    async handleUpdateDegree () {
      this.isEditing = false

      await this.updateDegree({ productId: this.detail.id, degree: this.data.degree })
    }
  },
  async beforeMount () {
    try {
      this.isLoading = true
      let response = await this.getDiagnostic({ productId: this.detail.id })
      this.data = response
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.table {
  border: 1px solid lightgray;
  border-radius: 15px;
  border-collapse: separate;
}
.table tr {
  border-bottom: 1px solid lightgray;
}
.table th {
  background-color: transparent !important;
  color: rgb(110, 110, 119) !important;
  padding: 0.5em 0.75em;
}
.has-background-color-a {
  background-color: #4CAF50;
}
.has-background-color-ab {
  background-color: #66BB6A;
}
.has-background-color-b {
  background-color: #fcd665;
}
.has-background-color-c {
  background-color: #FFCA28;
}

.promo-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  margin-bottom: 14px;
  font-size: 14px;
}
.promo-banner--active {
  background-color: #eef4ff;
  border: 1px solid #c9dbff;
}
.promo-banner--none {
  background-color: #f5f5f5;
  border: 1px solid #e4e4e4;
}
.promo-banner__label {
  font-weight: 700;
  color: #4a4a4a;
}
.promo-banner__partner {
  font-weight: 600;
  color: #2155cd;
}
.promo-banner--none .promo-banner__partner {
  color: #8a8a8a;
}
.promo-banner__code {
  font-family: monospace;
  font-size: 12px;
  color: #6a6a6a;
}
.price-origin {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  color: #4a4a4a;
  margin: -6px 0 12px;
}

.price-table {
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}
.price-table td {
  vertical-align: middle;
  padding: 0.45em 0.75em;
}
.price-table .price-cell {
  font-size: 17px;
  font-weight: 700;
  color: #363636;
}
.price-table__subhead td {
  background-color: #fafafa;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #7a7a7a;
}
.grade-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
}
.grade-dot--partner {
  background-color: #2155cd;
}
.grade-dot--consignment {
  background-color: #f9a825;
}
.price-row--shown {
  background-color: #effaf3;
}
.price-row--shown .price-cell {
  font-weight: 700;
}

.auto-test-reason {
  margin-left: 8px;
}

.auto-tests-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.info-table__key {
  font-weight: 600;
  color: #4a4a4a;
}
.info-table td {
  vertical-align: middle;
  padding: 0.45em 0.75em;
}

</style>
